<mat-card>
  <div style="position: absolute; right: 0; top: 0;">
    <mat-icon [matTooltip]="'Common.Close' | translate" (click)="this.dialogRef.close(false)">close</mat-icon>
  </div>
  <mat-card-title style="text-align: center;">{{ data.title | translate}}</mat-card-title>
</mat-card>
<buttons-prosegur [options]="myButtonOptions"></buttons-prosegur>